<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <el-card style="margin-bottom: 2rem;">
                        <p style="margin:0rem;font-style:normal;color:black">世界观</p>
                        <el-radio-group v-model="current_world" @change="handleCheckedWorldsChange" text-color="#fff"
                            fill="skyblue">
                            <el-radio-button v-for="world in worlds" :key="world" :label="world">{{ world
                                }}</el-radio-button>
                        </el-radio-group>
                    </el-card>
                    <div v-if="current_world == 'CSPA特别行动组行动报告'">
                        <h2 id="≺人世≻">CSPA特别行动组行动报告</h2>
                        <p>勇敢的少女拯救世界吧</p>
                        <el-divider />
                        <h3>世界观</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '≺人世≻_世界观'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>事件</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '≺人世≻_事件'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>地区</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '≺人世≻_地区'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>人物</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '≺人世≻_人物'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                    </div>
                    <div v-if="current_world == '泰尔兰大陆环游记'">
                        <h2 id="泰尔兰">泰尔兰大陆环游记</h2>
                        <p>泰尔兰大陆环游记&因兰魔法学院日常</p>
                        <el-divider />
                        <h3>世界观</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '泰尔兰_世界观'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>事件</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '泰尔兰_事件'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>地区</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '泰尔兰_地区'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>人物</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '泰尔兰_人物'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                    </div>
                    <div v-if="current_world == '狐狗狸大人摔倒了'">
                        <h2 id="其他">狐狗狸大人摔倒了</h2>
                        <p>只剩下你和我的旧校舍</p>
                        <el-divider />
                        <h3>世界观</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '其他_世界观'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>事件</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '其他_事件'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>地区</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '其他_地区'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                        <h3>人物</h3>
                        <ul v-for="(item, index) in content">
                            <li v-if="item['idx'] == '其他_人物'">
                                <a :href="'/article/' + item['title']">{{ item["title"] }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'

const title = "文档"
const subtitle = "出自一个绝望的文盲"
let content = ref([])
let current_world = ref('CSPA特别行动组行动报告')

const worlds = ['泰尔兰大陆环游记', 'CSPA特别行动组行动报告', '狐狗狸大人摔倒了', '第八十亿零一种结局']

const handleCheckedWorldsChange = value => {
    current_world.value = value;
}

const getData = () => {
    var api = "/article_list.php";
    axios.get(api).then((res) => {
        content.value = res.data;
    }).catch((err) => {
        console.log(err)
    })
}

onMounted(() => {
    getData()
})

function AddLi(title) {
    let oLi = document.createElement("li");
    let a = document.createElement("a");
    a.href = "/article/" + title;
    a.innerHTML = title;
    oLi.append(a);
    return oLi
}
function AddSubLi(title, hs) {
    let oLi = document.createElement("li");
    let a = document.createElement("a");
    a.href = "/article/" + title;
    a.innerHTML = hs;
    oLi.append(a);
    return oLi
}

function find_tag_h2(content) {
    // var re = /<h2>(.*?)<\/h2>/g;
    // var arr = [];
    // while (re.exec(content) != null) {
    //     arr.push(RegExp.$1);//如果是RegExp.$1那么匹配的就是href里的属性了!
    // }
    // return (arr);
    let arr = [];
    if (content) {
        let reg = /<h2(?:(?!<\/h2>).|\n)*?<\/h2>/gi;
        const arr = [...content.matchAll(reg)];
        return arr;
    }
    return (arr);

}
</script>
<style scoped>
p {
    margin: 0.7rem;
    font-style: italic;
    color: gray;
}

ul {
    margin-bottom: 1.5rem;
}
</style>